<template>
    <div class="page-wrapper">
        <!-- Success confirmation visible on page -->
        <div class="card">
            <div class="icon-wrapper">
                <div class="icon-circle">
                    <svg viewBox="0 0 24 24" class="check-icon">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M9 12l2 2 4-4"></path>
                    </svg>
                </div>
            </div>

            <div class="title-section">
                <h1>Registration Successful!</h1>
                <p>You have been successfully registered for the event</p>
            </div>

            <div class="details-box">
                <div class="reg-number">
                    <span>Registration Number</span>
                    <strong>{{ registrationNumber }}</strong>
                </div>

                <div class="details-grid">
                    <div>
                        <span>Participant Name</span>
                        <p>{{ participantName }}</p>
                    </div>
                    <div>
                        <span>Registration Date</span>
                        <p>{{ registrationDate }}</p>
                    </div>
                </div>
            </div>

            <div class="info-box">
                📱 You'll receive a confirmation via SMS/WhatsApp shortly
            </div>

            <div class="actions">
                <button class="btn primary" @click="download">
                    Download Confirmation
                </button>
                <button class="btn outline" @click="registerAnother">
                    Register Another Person
                </button>
                <button class="link-btn" @click="goHome">
                    Return to Home
                </button>
            </div>
        </div>

        <p class="footer">
            Need assistance? Contact us at support@caregiverevent.org
        </p>
    </div>
</template>

<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
    name: "SuccessConfirmation",
    data() {
        const state = history.state || {};
        return {
            registrationType: state.registrationType || "",
            registrationNumber: state.registrationNumber || "",
            participantName: state.participantName || "",
            registrationDate: state.registrationDate
                ? new Date(state.registrationDate).toLocaleString()
                : "",
            registrationTypeText: ""

        };
    },

    mounted() {
        this.checkRegType();
    },

    methods: {
        checkRegType() {
            if (this.registrationType === "self_registration") {
                this.registrationTypeText = "Self Registration";
            }else if(this.registrationType === "behalf_registration"){
                this.registrationTypeText = "Behalf Registration";
            }
        },
        async getQRCodeDataUrl() {
            const response = await fetch(`https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=Registration Number: ${this.registrationNumber}`);
            const blob = await response.blob();

            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result); // data URL
                reader.readAsDataURL(blob);
            });
        },
        async download() {
            const qrDataUrl = await this.getQRCodeDataUrl();
            // Create a temporary container in memory
            const container = document.createElement("div");
            container.style.position = "fixed";
            container.style.left = "-10000px"; // hide off-screen
            container.style.top = "0";
            document.body.appendChild(container);

            // Inject the ticket card HTML
            container.innerHTML = `
        <div class="ticket-card" style="
          background: #fff;
          border-radius: 18px;
          padding: 24px;
          box-shadow: 0 18px 40px rgba(0,0,0,0.12);
          max-width: 420px;
          text-align: center;
          font-family: Arial, sans-serif;">
          <div class="ticket-header" style="margin-bottom: 16px;">
            <h3 style="font-size:16px;font-weight:700;margin:0;">CAREGIVER EVENT REGISTRATION</h3>
            <p style="font-size:14px;color:#6c757d;margin-top:4px;">Registration Confirmation</p>
          </div>
          <div class="ticket-body">
            <div class="qr-wrapper" style="display:flex;justify-content:center;margin:20px 0;">
              <img src="${qrDataUrl}" alt="QR Code" style="width:200px;height:200px;">
            </div>
            <div class="ticket-info" style="text-align:left;font-size:14px;margin-bottom:16px;">
              <p><strong>Registration Number:</strong> <span>${this.registrationNumber}</span></p><br/>
              <p><strong>Participant Name:</strong> <span>${this.participantName}</span></p><br/>
              <p><strong>Registration Date:</strong> <span>${this.registrationDate}</span></p><br/>
              <p><strong>Registration Type:</strong> <span>${this.registrationTypeText}</span></p><br/>
            </div>
            <div class="info-box" style="
              background: #f59cab;
              border: 1px solid #f59cab;
              border-radius: 10px;
              padding: 12px;
              font-size: 14px;
              margin: 16px 0;
              text-align:center;">
              Thank you for registering! You will receive a confirmation via SMS/WhatsApp shortly.
            </div>
            <p style="font-size:13px;color:#f59cab;">For inquiries, contact: <a href="mailto:support@succour.care" style="color:#f59cab;text-decoration:none;">support@succour.care</a></p>
          </div>
        </div>
      `;

            // Capture it as canvas
            const canvas = await html2canvas(container, { scale: 2 });
            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF("p", "mm", "a4");
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = 210;
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

            pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
            pdf.save(`${this.registrationNumber}.pdf`);

            // Clean up
            document.body.removeChild(container);
        },
        registerAnother() {
            this.$router.push({
                name: this.registrationType === "self_registration" ? "SelfRegistration" : "BehalfRegistration",
            });
        },
        goHome() {
            this.$router.push({ name: "CgWorkshop" });
        },
    },
};
</script>

<style scoped>
/* Page */
.page-wrapper {
    min-height: 100vh;
    background: #f8f9fa;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px;
    font-family: system-ui, sans-serif;
}

/* Card */
.card {
    background: #ffffff;
    width: 100%;
    max-width: 640px;
    border-radius: 16px;
    padding: 32px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
}

/* Icon */
.icon-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
}

.icon-circle {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: var(--s-green-normal);
    display: flex;
    align-items: center;
    justify-content: center;
}

.check-icon {
    width: 56px;
    height: 56px;
    stroke: #ffffff;
    stroke-width: 2;
    fill: none;
}

/* Title */
.title-section {
    text-align: center;
    margin-bottom: 32px;
}

.title-section h1 {
    margin: 0 0 8px;
    color: #212529;
}

.title-section p {
    margin: 0;
    color: #6c757d;
}

/* Details */
.details-box {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 24px;
}

.reg-number {
    text-align: center;
    padding-bottom: 16px;
    border-bottom: 1px solid #ced4da;
    margin-bottom: 16px;
}

.reg-number span {
    display: block;
    font-size: 14px;
    color: #6c757d;
}

.reg-number strong {
    font-size: 22px;
    font-family: monospace;
    color: #212529;
}

.details-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    font-size: 14px;
}

.details-grid span {
    color: #6c757d;
}

.details-grid p {
    margin: 4px 0 0;
    color: #212529;
}

/* Info */
.info-box {
    background: #f59cab;
    border: 1px solid #f59cab;
    border-radius: 10px;
    padding: 12px;
    text-align: center;
    font-size: 14px;
    margin-bottom: 24px;
}

/* Actions */
.actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.btn {
    height: 48px;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
}

.btn.primary {
    background: #f59cab;
    color: #ffffff;
    border: none;
}

.btn.primary:hover {
    background: #f59cab;
}

.btn.outline {
    background: transparent;
    border: 1px solid #f59cab;
    color: #f59cab;
}

.btn.outline:hover {
    background: #f59cab;
    color: #ffffff;
}

.link-btn {
    background: none;
    border: none;
    color: #f59cab;
    font-size: 14px;
    cursor: pointer;
    margin-top: 4px;
}

.link-btn:hover {
    text-decoration: underline;
}

/* Footer */
.footer {
    margin-top: 24px;
    font-size: 14px;
    color: #6c757d;
    text-align: center;
}
</style>
